import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'lgr-card-highlighted',
  styleUrl: 'cardHighlighted.scss',
  shadow: true,
})
export class CardHighlighted {

  /**
   * Tag's text
   */
  @Prop() tagsText!: string;
  /**
   * Short image variation
   */
  @Prop() shortImage: boolean = false;

  render() {
    return (
      <Host>
        <div
          class={{
            "lgr-card-highlighted": true,
            "lgr-card-highlighted-short": this.shortImage
          }}
        >
          <div class="image-wrapper">
            <slot/>
          </div>
          <div class="text-button-wrapper">
            <div class="text-wrapper">
              <lgr-tag tag={this.tagsText} variant="warning"></lgr-tag>
              <slot name="title"></slot>
              <slot name="authors"></slot>
            </div>
            <slot name="button"></slot>
          </div>
        </div>
      </Host>
    );
  }

}
